<template>
    <span class="text-danger">
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Desassociar Despesa"
            @click.stop="confirmarDesassociar(pagamentoDespesa.pagamentoDespesaId)"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentoDespesa: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarDesassociar(pagamentoDespesaId) {
            this.$swal({
                title: 'Desassociação de Despesa',
                html: `Confirma a desassociação da despesa?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.desassociar(pagamentoDespesaId)
                }
            })
        },

        desassociar(pagamentoDespesaId) {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .desassociarDespesa({
                    pagamentoId: this.$route.params.pagamentoId,
                    pagamentoDespesaId: pagamentoDespesaId
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                        } else {
                            this.$toast.error(
                                'Erro ao desassociar despesa do pagamento.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {}
}
</script>
